import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AppError, unifiedApi } from 'merchant-api';
import { analytics, LoginLayout, LoginServer } from 'merchant-components';
import { useQuery } from '@tanstack/react-query';
import { LoadingAnimation } from '@odmonorepo/core-components';

// The signed-in gate: /client/user/v1/profile 200s only for a real user session. The unified
// client turns a 401/403 (after its refresh retry) into AppError.Unauthenticated.
const profileOpts = () => ({
  ...unifiedApi.queryOptions('get', '/client/user/v1/profile'),
  retry: false,
  staleTime: 1000 * 60 * 5,
});

const RouteComponent = () => {
  const { data, isPending, error } = useQuery({ ...profileOpts(), throwOnError: false });
  if (isPending)
    return (
      <div className="mx-auto">
        <LoadingAnimation />
      </div>
    );
  if (error || !data) throw AppError.Unauthenticated;
  return <Outlet />;
};

export const Route = createFileRoute('/_merchant')({
  staleTime: 1000 * 60 * 5,
  beforeLoad: async ({ context }) => {
    let user;
    try {
      user = await context.queryClient.fetchQuery(profileOpts());
    } catch {
      return;
    }
    if (!user) return;
    const anonymousId = analytics.getUserId();
    analytics.identify(anonymousId || user.userId, {
      userId: user.userId,
      email: user.email,
      anonymousId,
      isAnonymous: false,
    });
  },
  component: RouteComponent,
  errorComponent: ({ error }) => {
    if (error instanceof AppError && error.name === 'Unauthenticated') return <LoginLayout outlet={<LoginServer redirect={window.location.pathname + window.location.search} />} />;
    throw error;
  },
});
